<template>
  <div v-if="mergado.arukereso.active" class="mb-1 mergado-consent">
    <div class="form-check mergado-arukereso-consent">
      <input id="mergado_arukereso_consent_checkbox" type="checkbox" class="form-check-input" :checked="mergado.arukereso.checked" @change="updateValue">
      <label class="form-check-label" for="mergado_arukereso_consent_checkbox">
        {{ mergado.arukereso.text }}
      </label>
    </div>
  </div>
</template>

<script>
import {mapState} from 'vuex';

export default {
  computed: {
    ...mapState({
      mergado: state => state.mergado,
    }),
  },
  methods: {
    updateValue (e) {
      this.$store.commit('mergado/SET_ARUKERESO', e.target.checked);
    }
  },
};
</script>
